import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from '@src/design-system/empty';
import { Button } from '@src/design-system/button';
import { useEffect, useState } from 'react';
import { useTableStates } from './hooks/use-table-states';

function hasActiveFilters(
  globalFilter: Record<string, unknown> | undefined
): boolean {
  if (!globalFilter || typeof globalFilter !== 'object') return false;
  return Object.values(globalFilter).some((v) => v != null && v !== '');
}

const NoResultsFoundSvg = () => {
  return (
    <svg
      width='200'
      height='200'
      viewBox='10 10 240 240'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='138.75'
        cy='148.75'
        r='87.75'
        fill='#F1F3FF'
      />
      <circle
        cx='56.5'
        cy='89.5'
        r='5.5'
        fill='#F1F3FF'
      />
      <circle
        cx='201.25'
        cy='53.75'
        r='10.25'
        fill='#F1F3FF'
      />
      <circle
        cx='58.25'
        cy='205.25'
        r='9.75'
        fill='#F1F3FF'
      />
      <circle
        cx='232.75'
        cy='195.75'
        r='9.75'
        fill='#F1F3FF'
      />
      <circle
        cx='213.75'
        cy='206.75'
        r='4.75'
        fill='#F1F3FF'
      />
      <path
        d='M237.329 165.665L238.861 172.899L245.991 174.452L238.861 176.005L237.329 183.239L235.798 176.005L228.668 174.452L235.798 172.899L237.329 165.665Z'
        fill='white'
      />
      <path
        d='M228.172 91.811C228.284 91.2824 229.039 91.2824 229.151 91.811L230.126 96.4175C230.166 96.6099 230.316 96.7606 230.508 96.8025L235.08 97.7985C235.605 97.9128 235.605 98.6613 235.08 98.7756L230.508 99.7716C230.316 99.8135 230.166 99.9641 230.126 100.157L229.151 104.763C229.039 105.292 228.284 105.292 228.172 104.763L227.197 100.157C227.157 99.9641 227.007 99.8135 226.815 99.7716L222.243 98.7756C221.718 98.6613 221.718 97.9128 222.243 97.7985L226.815 96.8025C227.007 96.7606 227.157 96.6099 227.197 96.4175L228.172 91.811Z'
        fill='#C4CBF5'
      />
      <path
        d='M46.6115 152.311C46.7233 151.782 47.4779 151.782 47.5898 152.311L49.2612 160.207C49.3019 160.4 49.4517 160.55 49.6439 160.592L57.4587 162.295C57.9834 162.409 57.9834 163.157 57.4587 163.272L49.6439 164.974C49.4517 165.016 49.3019 165.167 49.2612 165.359L47.5898 173.255C47.4779 173.784 46.7233 173.784 46.6115 173.255L44.94 165.359C44.8993 165.167 44.7495 165.016 44.5573 164.974L36.7426 163.272C36.2178 163.157 36.2178 162.409 36.7426 162.295L44.5573 160.592C44.7495 160.55 44.8993 160.4 44.94 160.207L46.6115 152.311Z'
        fill='#C4CBF5'
      />
      <path
        d='M77.7627 68.2685C77.4728 68.2069 77.4728 67.7931 77.7627 67.7315L82.1455 66.7995C82.2511 66.777 82.3338 66.6947 82.3567 66.5891L83.3004 62.2372C83.3629 61.9487 83.7744 61.9487 83.8369 62.2372L84.7806 66.5891C84.8035 66.6947 84.8861 66.777 84.9918 66.7995L89.3746 67.7315C89.6645 67.7931 89.6645 68.2069 89.3746 68.2685L84.9918 69.2005C84.8861 69.223 84.8035 69.3053 84.7806 69.4109L83.8369 73.7628C83.7744 74.0513 83.3629 74.0513 83.3004 73.7628L82.3567 69.4109C82.3338 69.3053 82.2511 69.223 82.1455 69.2005L77.7627 68.2685Z'
        fill='#C4CBF5'
      />
      <circle
        cx='157'
        cy='116.5'
        r='55.5'
        fill='#DDE2FF'
        stroke='#C4CBF5'
        stroke-width='2'
      />
      <circle
        cx='157'
        cy='116.5'
        r='46.5'
        fill='#F1F3FF'
        stroke='#C4CBF5'
        stroke-width='2'
      />
      <path
        d='M84.6221 219.313L114.618 177.652L115.951 176.652L118.951 175.985H123.284L125.617 177.652L127.95 178.652L129.95 180.985L131.616 184.651L105.619 233.645L102.62 235.311H98.9536L93.9542 233.645L89.9547 231.978L86.2885 226.979L84.6221 224.979V219.313Z'
        fill='#DDE2FF'
      />
      <path
        d='M137.282 168.653L129.677 180.985'
        stroke='#C4CBF5'
        stroke-width='2'
      />
      <path
        d='M128.344 164.653L121.012 175.652'
        stroke='#C4CBF5'
        stroke-width='2'
      />
      <path
        d='M116.618 175.985L84.2886 220.313'
        stroke='#C4CBF5'
        stroke-width='2'
      />
      <path
        d='M131.283 183.984L105.286 234.311'
        stroke='#C4CBF5'
        stroke-width='2'
      />
      <path
        d='M115.951 176.652L116.5 176.346C117.7 175.678 119.079 175.402 120.444 175.556C121.002 175.62 121.549 175.754 122.072 175.956L123.011 176.318L123.328 176.424C125.093 177.012 126.696 178.003 128.011 179.318L129.045 180.352C129.465 180.772 129.832 181.242 130.138 181.752C130.495 182.348 130.766 182.993 130.941 183.666L131.283 184.984'
        stroke='#C4CBF5'
        stroke-width='2'
      />
      <path
        d='M105.953 233.645L104.533 234.283C103.158 234.902 101.675 235.244 100.168 235.292C98.9974 235.328 97.8282 235.187 96.7005 234.871L95.7443 234.603L95.4237 234.495C92.5902 233.533 90.0098 231.946 87.8741 229.85L86.6395 228.638C85.6741 227.691 84.9507 226.526 84.53 225.24C84.0068 223.641 83.9735 221.923 84.4345 220.305L84.622 219.646'
        stroke='#C4CBF5'
        stroke-width='2'
      />
    </svg>
  );
};

export const TableEmptyState = () => {
  const { tableFilters } = useTableStates();

  const hasFilters = hasActiveFilters(tableFilters);

  const [button, setButton] = useState<HTMLButtonElement | null>(null);

  useEffect(() => {
    const button = document.querySelector('[data-ticlick-table-action]');
    setButton(button as HTMLButtonElement);
    return () => {
      setButton(null);
    };
  }, []);

  return (
    <Empty>
      <EmptyHeader>
        <NoResultsFoundSvg />

        <EmptyTitle className='text-gray-900 font-medium'>
          {hasFilters ? 'No results found' : 'No data yet'}
        </EmptyTitle>
        <EmptyDescription className='text-gray-700'>
          {hasFilters
            ? "Try adjusting your search or filters to find what you're looking for."
            : 'There are no items to display in this list. Add your first item to get started.'}
        </EmptyDescription>
        {!hasFilters && button && (
          <EmptyContent className='flex-row justify-center gap-2 mt-2'>
            <Button
              size='sm'
              onClick={() => button.click()}
            >
              Add Item
            </Button>
          </EmptyContent>
        )}
      </EmptyHeader>
    </Empty>
  );
};
